module.exports = __webpack_public_path__ + "img/jpg-preview.0e4aa36.png";